import { useEffect, useRef } from 'react';

import {
  disableWindowScroll,
  enableWindowScroll,
} from '@utils/common';

/*
  This hook allows to disable body scrolling when `isScrollDisabled === true`;
 */
export const useDisableBodyScrollEffect = (isScrollDisabled: boolean) => {
  const isInitialRenderRef = useRef(true);

  useEffect(
    () => {
      if (isScrollDisabled) {
        disableWindowScroll();
        // We think that initially scroll enabled and don't enable it again
        // on first render
      } else if (!isInitialRenderRef.current) {
        enableWindowScroll();
      } else {
        isInitialRenderRef.current = false;
      }
    },
    [isScrollDisabled],
  );
};
